import { genesisNftVestingContract } from '@contracts/tge-vesting/genesis-nft-vesting'
import { web3Config } from '@config/web3.config.ts'
import { genesisNFTVestingStakingContract } from '@contracts/tge-vesting/genesis-nft-vesting-staking'

export const vestingContracts = [
  {
    contract: genesisNftVestingContract,
    address: web3Config.vesting.genesisNFTVesting.address,
    function: 'released',
  },
  {
    contract: genesisNFTVestingStakingContract,
    address: web3Config.vesting.stakingGenesisNFTVesting.address,
    function: 'releasedAmount',
  },

  // Commented out because these contracts are not deployed yet
]
